import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=7a29763d&"
import script from "./Admins.vue?vue&type=script&lang=js&"
export * from "./Admins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/apps2/privacy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a29763d')) {
      api.createRecord('7a29763d', component.options)
    } else {
      api.reload('7a29763d', component.options)
    }
    module.hot.accept("./Admins.vue?vue&type=template&id=7a29763d&", function () {
      api.rerender('7a29763d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Admins.vue"
export default component.exports